<template>
  <ReportsPageV2
    :product="NEW_TECHNOLOGY"
    :hero-image="newTechnologyData.hero"
    :tabs="tabs"
    :active-tab="activeTab"
    @set-active-tab="setActiveTab"
  >
    <template v-if="!authenticated" #downloadButton>
      <ButtonDownload
        data-testid="download-button"
        class="mx-0 w-full text-sm font-semibold leading-5 xl:max-w-fit"
        variant="clean"
        text="Forecast Brochure"
        :download-file="file"
      />
    </template>
    <NuxtPage />
  </ReportsPageV2>
</template>

<script setup lang="ts">
import ReportsPageV2 from '~/components/market/ReportsPageV2.vue'
import ButtonDownload from '~/components/shared/common/ButtonDownload.vue'
import newTechnologyData from '~/constants/data-reports/new-technology'
import { FORECASTS, NEW_TECHNOLOGY } from '~/constants/services/constants'
import type { TTab } from '~/src/types/ui'

const BASE_URL = `/${NEW_TECHNOLOGY.slug}/data-reports`
const TAB_FILE_MAP = {
  forecasts: newTechnologyData.forecastBrochureFile,
}

const { getSeoInfo } = useSeo()
const config = useRuntimeConfig()
const authStore = useAuthStore()

const titlePage = `${NEW_TECHNOLOGY.name} Data and Reports`
const seo = getSeoInfo({
  title: titlePage,
  description:
    'Discover the next-generation market leaders and battery innovators reshaping the energy sector. Our reports and data create new supply chain opportunities.',
})

const activeTab = ref<string | null>(null)

const authenticated = computed(() => authStore.authenticated)

const tabs = computed((): TTab[] => [
  {
    name: FORECASTS.name,
    slug: 'forecasts',
    url: `${BASE_URL}/forecasts`,
  },
])

const file = computed(() => {
  if (!activeTab.value) return {}
  const selectedFile = TAB_FILE_MAP[activeTab.value]

  if (!selectedFile) return {}

  return {
    ...selectedFile,
    id: selectedFile.EnvKey ? config.public[selectedFile.EnvKey] : '',
  }
})

const setActiveTab = (tab: string) => {
  activeTab.value = tab
}

useHead({
  ...seo,
  title: `Benchmark Mineral Intelligence: ${titlePage}`,
})
</script>
